var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": "#",
      "title": "云永云商城"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r-box fr"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mycart ml25"
  }, [_c('i', {
    staticClass: "ico-orders"
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.goOrder('')
      }
    }
  }, [_vm._v("我的订单 "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.allCount))])]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list orders"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_pay')
      }
    }
  }, [_vm._v("等待买家付款 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("等待卖家发货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sendCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_confirm_goods')
      }
    }
  }, [_vm._v("等待确认收货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.putCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_finish')
      }
    }
  }, [_vm._v("订单完成 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.receiveCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_close')
      }
    }
  }, [_vm._v("订单关闭 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.closeCount))])])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn"
  }, [_vm._v("搜索")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mycart"
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v("0")]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/settleup-nogoods.png"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "li-1"
  }, [_c('span', {
    staticClass: "fr"
  }, [_vm._v("小计：￥599.00")])]), _vm._v(" "), _c('li', {
    staticClass: "li-2"
  }, [_c('a', {
    staticClass: "fl spic",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/temp/zcjy-1.jpg"),
      "width": "50",
      "height": "50"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("一种超硬物料自动破碎装置物料自动破碎装置")])]), _vm._v(" "), _c('p', {
    staticClass: "other"
  }, [_c('span', [_vm._v("￥599.00×1")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "del",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("删除")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共2件商品　共计"), _c('b', [_vm._v("￥ 738.00")])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去购物车")])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a5ac146","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmallHeader.vue
// module id = Gias
// module chunks = 1